import { fetchJSON } from "./utils";

const BASE_URL = "/api/v2/code_orchestrator";

const fetchArtifacts = (type, organizationId, options = {}) =>
  fetchJSON(
    `${BASE_URL}/artifacts/${type}`,
    { organization_id: organizationId, ...options },
    null,
    "get",
  );

export const fetchApps = (organizationId, options = {}) =>
  fetchArtifacts("apps", organizationId, options);

export const fetchWorkflows = (organizationId, options = {}) =>
  fetchArtifacts("workflows", organizationId, options);

export const fetchArtifact = (organizationId, artifactId, type) =>
  fetchJSON(
    `${BASE_URL}/artifacts/${artifactId}`,
    { organization_id: organizationId, type },
    null,
    "get",
  );

export const fetchWorkflow = async (organizationId, artifactId) => {
  const response = await fetchWorkflows(organizationId, {
    artifact_id: artifactId,
    limit: 1,
    runs_limit: 10,
  });
  return response.items[0];
};

export const fetchArtifactHistory = (organizationId, artifactId, type) =>
  fetchJSON(
    `${BASE_URL}/artifacts/${artifactId}/history`,
    { organization_id: organizationId, type },
    null,
    "get",
  );

export const fetchExecutions = (organizationId, options = {}) =>
  fetchJSON(
    `${BASE_URL}/executions`,
    { organization_id: organizationId, ...options },
    null,
    "get",
  );

export const fetchExecution = (organizationId, executionId) =>
  fetchJSON(
    `${BASE_URL}/executions/${executionId}`,
    { organization_id: organizationId },
    null,
    "get",
  );

export const fetchExecutionOutputDownloadUrl = (
  organizationId,
  executionId,
  outputName,
) =>
  fetchJSON(
    `${BASE_URL}/executions/${executionId}/outputs/download`,
    { organization_id: organizationId, output_name: outputName },
    null,
    "get",
  );
